import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'fin-booking-plain-header-area',
  templateUrl: './booking-plain-header-area.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class BookingPlainHeaderAreaComponent {
  @Input()
  title: string;
  @Input()
  subtitle: string;
  @Input()
  extraText?: string;
  @Input()
  headingClass = 'nordic-blue-900-text text-icon-primary';
  @Input()
  enableBottomPadding = true;
  @Input()
  enableTopPadding = true;
}
